import { render, staticRenderFns } from "./CustomerList080.vue?vue&type=template&id=3ef10dcf"
import script from "./CustomerList080.vue?vue&type=script&lang=js"
export * from "./CustomerList080.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports